import { absentWord, type ChildGender } from "@/lib/child-grammar";

export type MarkSummary = {
  absent: boolean;
  breakfast: boolean | null;
  afterschool: boolean | null;
  note?: string;
};

export function describeMark(mark: MarkSummary, gender: ChildGender = "girl") {
  const note = mark.note?.trim();
  if (mark.absent) {
    const absent = absentWord(gender);
    return note ? `${absent} · ${note}` : absent;
  }
  const parts = ["буде"];
  if (mark.breakfast) parts.push("сніданок");
  else parts.push("без сніданку");
  if (mark.afterschool) parts.push("група");
  else parts.push("додому");
  if (note) parts.push(note);
  return parts.join(" · ");
}
